import { render } from "./Spinner.vue?vue&type=template&id=1ffa35db&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=1ffa35db&scoped=true&lang=scss"
import "./Spinner.vue?vue&type=style&index=1&id=1ffa35db&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffa35db"]])

export default __exports__